<ng-container *ngIf="tipPojavnogOblika$ | async as tipPojavnogOblika">
        <ng-container *ngIf="activeTab === 0">
        <div [ngSwitch]="tipPojavnogOblika">
            <div *ngSwitchCase="'FIZICKI'">
                <app-fizicki-objekt-lista></app-fizicki-objekt-lista>
            </div>
            <div *ngSwitchCase="'DIGITALNI'">
                <app-datoteke-lista [viewName]="(parentViewName$ | async) ?? 'datoteke'"></app-datoteke-lista>
            </div>
            <div *ngSwitchDefault>Odaberite tip pojavnog oblika za dodavanje vezanih objekata.</div>
        </div>
    </ng-container>
</ng-container>